var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorderLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 283,
    height: 436,
    viewBox: "0 0 283 436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alex_Portret_yellow",
    "data-name": "Alex Portret yellow",
    fill: "none",
    stroke: "#90c900",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 283,
    height: 436,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 273,
    height: 426,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderLight);
export default __webpack_public_path__ + "static/media/BorderLight.1fa3797633f2b8974aac6250c11cb16f.svg";
export { ForwardRef as ReactComponent };